//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Donation from "~/components/home/Donation";
import MtArrowLink from "../other/MtArrowLink";
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import { handleTouchScroling } from '~/utils/utils';
export default {
  components: {
    Donation,
    MtArrowLink
  },
  data() {
    return {
      y: 0,
      down: false
    }
  },
  mounted() {
    const body = document.body
    body.addEventListener('touchmove', function(event) {
      event.preventDefault();
    });
  },
  beforeDestroy() {
    const body = document.body
    body.removeEventListener('touchmove', function(event) {
      event.preventDefault();
    });
  },
  methods: {
    openLink() {
      this.$store.commit('forms/closeDonatForm')
      window.location.href = '/app/terms'
    }
  },
  // computed: {
  //   eventsListeners() {
  //     return {
  //       ...this.$listeners,
  //       ...handleTouchScroling(this, 'homeDonationForm')
  //     }
  //   },
  // },
  // props:{
  //   chooseMasterpiece: {
  //     type: Boolean,
  //     default: false
  //   }
  // },
}
